/**
 * Geographic and mathematical constants
 */

export const EARTH_RADIUS_METERS = 6371000;

export const METERS_TO_DEGREES = 1 / 111320;
export const DEGREES_TO_RADIANS = Math.PI / 180;
export const RADIANS_TO_DEGREES = 180 / Math.PI;

export const DEFAULT_RADIUS_METERS = 1000;
export const DEFAULT_RADIUS_FROM_BOUNDS_METERS = 50000;

export const AZIMUTH_POLYGON = {
  SPREAD_ANGLE_DEGREES: 40,
  DISTANCE_DEGREES: 0.01, // ~1km in degrees (approximate)
  STEPS: 50,
} as const;

export const CIRCLE_GENERATION = {
  STEPS: 64,
} as const;

export const COORDINATE_PRECISION = 6;
